import api from "./api";
import { obtenerUsuario } from "./authService";

// Servicio de bitacora y centralizacion de ejecucion de reportes
// basado en el estandar SSIS/SSRS ExecutionLog.

export const getsBitacoraReportes = async (filtros = {}) => {
    const params = new URLSearchParams();
    if (filtros.reportPath) params.append("reportPath", filtros.reportPath);
    if (filtros.userName) params.append("userName", filtros.userName);
    if (filtros.format) params.append("format", filtros.format);
    if (filtros.status) params.append("status", filtros.status);
    if (filtros.fechaInicio) params.append("fechaInicio", filtros.fechaInicio);
    if (filtros.fechaFin) params.append("fechaFin", filtros.fechaFin);
    if (filtros.limite) params.append("limite", filtros.limite);

    const query = params.toString() ? `?${params.toString()}` : "";
    const respuesta = await api.get(`/BitacoraReporte/Gets${query}`);
    return respuesta.data || [];
};

export const getMetricasBitacoraReportes = async (fechaInicio, fechaFin) => {
    const params = new URLSearchParams();
    if (fechaInicio) params.append("fechaInicio", fechaInicio);
    if (fechaFin) params.append("fechaFin", fechaFin);

    const query = params.toString() ? `?${params.toString()}` : "";
    const respuesta = await api.get(`/BitacoraReporte/Metricas${query}`);
    return respuesta.data || {};
};

// Registro asincrono en segundo plano de la ejecucion de un reporte
export const registrarEjecucionReporte = async ({
    reportPath,
    userName,
    format = "HTML",
    parameters = null,
    reportAction = "Render",
    timeStart,
    timeEnd,
    timeDataRetrieval = 0,
    timeProcessing = 0,
    timeRendering = 0,
    status = "rsSuccess",
    rowCount = 0
}) => {
    try {
        const payload = {
            reportPath: reportPath || "/Reporte/General",
            userName: userName || obtenerUsuario() || "ANONIMO",
            format: format ? format.toUpperCase() : "HTML",
            parameters: typeof parameters === "object" && parameters !== null
                ? JSON.stringify(parameters)
                : (parameters ? String(parameters) : null),
            reportAction: reportAction || "Render",
            timeStart: timeStart instanceof Date ? timeStart.toISOString() : (timeStart || new Date().toISOString()),
            timeEnd: timeEnd instanceof Date ? timeEnd.toISOString() : (timeEnd || new Date().toISOString()),
            timeDataRetrieval: Math.max(0, Math.round(timeDataRetrieval || 0)),
            timeProcessing: Math.max(0, Math.round(timeProcessing || 0)),
            timeRendering: Math.max(0, Math.round(timeRendering || 0)),
            status: status || "rsSuccess",
            rowCount: Math.max(0, parseInt(rowCount, 10) || 0)
        };

        await api.post("/BitacoraReporte/Registrar", payload);
    } catch (err) {
        // La bitacora nunca interrumpe el flujo principal del reporte
        console.warn("No se pudo registrar la bitacora de reporte:", err?.message || err);
    }
};

// Ejecutor centralizado para reportes con metrica de tiempos
export const ejecutarReporteCentralizado = async ({
    reportPath,
    format = "HTML",
    parameters = null,
    reportAction = "Render",
    fetchData,
    processData
}) => {
    const timeStart = new Date();
    const t0 = performance.now();
    let data = null;
    let timeDataRetrieval = 0;
    let timeProcessing = 0;
    let rowCount = 0;
    let status = "rsSuccess";

    try {
        if (typeof fetchData === "function") {
            const fetchStart = performance.now();
            data = await fetchData();
            timeDataRetrieval = performance.now() - fetchStart;
        }

        if (typeof processData === "function") {
            const procStart = performance.now();
            data = await processData(data);
            timeProcessing = performance.now() - procStart;
        }

        rowCount = Array.isArray(data) ? data.length : (data?.filas?.length || 0);
        return data;
    } catch (error) {
        status = error?.response?.status ? `HTTP_${error.response.status}` : (error?.message || "ERROR_EJECUCION");
        throw error;
    } finally {
        const timeEnd = new Date();
        const totalMs = performance.now() - t0;
        const timeRendering = Math.max(0, totalMs - timeDataRetrieval - timeProcessing);

        // Envío asincrono a bitacora
        registrarEjecucionReporte({
            reportPath,
            format,
            parameters,
            reportAction,
            timeStart,
            timeEnd,
            timeDataRetrieval,
            timeProcessing,
            timeRendering,
            status,
            rowCount
        });
    }
};

